import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Carousel } from "react-bootstrap";
import "./NewLanding.css";

// Import hero images
import bellMathsHero from "../../images/Hero1/BellMaths-1.png";
import bellDiaryHero from "../../images/Hero1/BellDairy-1.png";
import encycGamesHero from "../../images/Hero1/Encycgames-1.png";
import notebookPencil from "../../images/Notebook-pencil.png";

// Product data
const featuredProducts = [
  {
    id: "bellmaths",
    name: "BellMaths",
    category: "EdTech",
    aiLabel: "AI",
    description: "Advanced AI-powered mathematics learning platform for students and educators",
    logo: "/belldairy/BellDairyLogo.png", // Placeholder - update with actual logo
    domain: "https://www.bellmaths.com", // Placeholder - update with actual domain
    carousel: [
      {
        image: bellMathsHero,
        title: "Paperless Maths Practice",
        description: "Engage with AI-powered math problems and solutions"
      }
    ]
  },
  {
    id: "encycgames",
    name: "EncycGames",
    category: "Sports Tech",
    aiLabel: "AI",
    description: "Unified multi-sport learning, assessment and performance for all ages and levels. Build foundations and progress through clear pathways.",
    logo: "/belldairy/BellDairyLogo.png", // Placeholder - update with actual logo
    domain: "https://www.encycgames.com", // Placeholder - update with actual domain
    carousel: [
      {
        image: encycGamesHero,
        title: "Multi-Sport Learning Pathways",
        description: "Unified multi-sport learning, assessment and performance for all ages and levels. Build foundations and progress through clear pathways."
      }
    ]
  },
  {
    id: "belldiary",
    name: "BellDiary",
    category: "EdTech",
    aiLabel: "AI",
    logo: "/belldairy/BellDairyLogo.png",
    domain: "https://www.belldiary.com",
    carousel: [
      {
        image: bellDiaryHero,
        // OLD - commented out: title: "Personal Brand Development", description: "Build your professional identity and showcase your achievements"
        title: "From Syllabus to Mastery",
        description: "Transforming syllabi into comprehensive textbooks, schedules, and labs through agentic AI. Collaborate in real-time to simplify the journey from curriculum to mastery."
      }
    ]
  }
];

// Services data
const featuredServices = [
  {
    id: "consulting",
    title: "IT Consulting Services",
    description: "Digital transformation journey with people, process and technology expertise",
    carousel: [
      {
        quote: "We help businesses achieve digital transformation with comprehensive IT strategy, technology architecture, and solution development.",
        author: "Encycdata Team"
      }
    ],
    items: [
      "IT Strategy and Digital Transformation",
      "Product Management and Development",
      "Technology and Architecture",
      "Software, Platform and Solution Development",
      "Application modernization",
      "Infrastructure and cloud solutions"
    ]
  },
  // EdTech Solutions and Services removed
  // {
  //   id: "training",
  //   title: "EdTech Solutions and Services",
  //   description: "Unique learning platform for students, teachers and professionals",
  //   carousel: [
  //     {
  //       image: "/belldairy/BellDairyLogo.png",
  //       title: "Role-Based Learning",
  //       description: "Specialized learning paths for career development"
  //     },
  //     {
  //       image: "/belldairy/BellDairyLogo.png",
  //       title: "Project-Based Training",
  //       description: "Real-time project-based learning experiences"
  //     },
  //     {
  //       image: "/belldairy/BellDairyLogo.png",
  //       title: "Mentorship Programs",
  //       description: "Professional mentorship and skill development"
  //     }
  //   ],
  //   items: [
  //     "Role based learning for any specialization",
  //     "Realtime Project based learning",
  //     "Instructor Led learning",
  //     "Mentorship",
  //     "Softskill development",
  //     "Entrepreneurship"
  //   ]
  // },
  {
    id: "staffing",
    title: "Staffing and Recruitment Services",
    description: "Talented and experienced resources for all technologies",
    carousel: [
      {
        quote: "From contract-to-hire to permanent placements, we offer comprehensive staffing solutions that scale with your business requirements.",
        author: "Encycdata Team"
      }
    ],
    items: [
      "Software Development",
      "Infrastructure services",
      "Quality Assurance",
      "Security Services",
      "Consulting Services",
      "Executive and CxO Advisory Services"
    ]
  },
  // Event Management Services hidden
  // {
  //   id: "events",
  //   title: "Event Management Services",
  //   description: "Event management platform to engage audience in unique way",
  //   items: [
  //     "Virtual Events",
  //     "Interpretor services",
  //     "Job Fairs",
  //     "Networking and community development",
  //     "Marketplace"
  //   ]
  // }
];

const NewLanding = () => {
  const [activeProduct, setActiveProduct] = useState(featuredProducts[0]);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [activeService, setActiveService] = useState(featuredServices[0]);
  const [serviceCarouselIndex, setServiceCarouselIndex] = useState(0);

  const handleProductHover = (product) => {
    setActiveProduct(product);
    setCarouselIndex(0);
  };

  const handleCarouselSelect = (selectedIndex) => {
    setCarouselIndex(selectedIndex);
  };

  const handleServiceHover = (service) => {
    setActiveService(service);
    setServiceCarouselIndex(0);
  };

  const handleServiceCarouselSelect = (selectedIndex) => {
    setServiceCarouselIndex(selectedIndex);
  };

  return (
    <div className="new-landing-container">
      {/* Main Title at the Top */}
      <div className="main-title-section">
        <div className="main-title-row">
          <div className="title-container">
            <h1 className="hero-main-title-above-products">
              {[
                "Build",
                "Strong",
                "Foundation",
                "with",
                "AI",
                "Powered",
                "Structured",
                "Learning",
                "and",
                "Pathway",
                "for",
                "Academic",
                "and",
                "Sports",
              ].map((word, index) => (
                <span
                  key={`${word}-${index}`}
                  className={`title-word title-word-${(index % 10) + 1}`}
                >
                  {word}{" "}
                </span>
              ))}
            </h1>
          </div>
          {/* Notebook image hidden for now
          <div className="hero-title-image-wrap">
            <img
              src={notebookPencil}
              alt="Academic and sports education"
              className="hero-title-image"
            />
          </div>
          */}
        </div>
      </div>

      {/* Featured Products Section */}
      <div className="hero-section">
        <Row className="hero-row">
          {/* Left Side - Product Carousel */}
          <Col md={7} className="hero-carousel-col">
            <div className="hero-content">
              <div className="product-carousel-wrapper">
                <Carousel
                  activeIndex={carouselIndex}
                  onSelect={handleCarouselSelect}
                  interval={false}
                  indicators={activeProduct.carousel.length > 1}
                  controls={activeProduct.carousel.length > 1}
                  className="product-carousel"
                >
                  {activeProduct.carousel.map((slide, index) => (
                    <Carousel.Item key={index}>
                      <div className="carousel-slide">
                        <img
                          src={slide.image}
                          alt={slide.title}
                          className="carousel-image"
                        />
                        <div className="carousel-content">
                          <h3 className="carousel-title-gradient">{slide.title}</h3>
                          <p>{slide.description}</p>
                        </div>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
                <div className="product-launch-btn">
                  <a
                    href={activeProduct.domain}
                    target="_blank"
                    rel="noreferrer"
                    className="launch-link"
                  >
                    Launch {activeProduct.name} →
                  </a>
                </div>
              </div>
            </div>
          </Col>

          {/* Right Side - Featured Products */}
          <Col md={5} className="featured-products-col">
            <div className="featured-section">
              <h2 className="section-title">Featured Products</h2>
              <div className="products-list-zoho">
                {featuredProducts.map((product) => (
                  <div
                    key={product.id}
                    className={`product-item-zoho ${
                      activeProduct.id === product.id ? "active" : ""
                    }`}
                    onMouseEnter={() => handleProductHover(product)}
                    onClick={() => handleProductHover(product)}
                  >
                    <div className="product-item-content">
                      <div className="product-text">
                        <h4 className={`product-name-zoho product-name-${product.id}`}>
                          <span className="product-name-main">{product.name}</span>{" "}
                          <span className="product-category-badge">{product.category}</span>{" "}
                          <span className="product-ai-badge">{product.aiLabel}</span>
                        </h4>
                        <p className="product-description-zoho">{product.carousel?.[0]?.description ?? product.description}</p>
                      </div>
                      <span className="product-arrow">→</span>
                    </div>
                  </div>
                ))}
              </div>
              <a href="/products" className="explore-all-link">
                Explore all products →
              </a>
            </div>
          </Col>
        </Row>
      </div>

      {/* Featured Services Section */}
      <div className="hero-section services-hero-section">
        <Row className="hero-row">
          {/* Left Side - Service Carousel */}
          <Col md={7} className="hero-carousel-col">
            <div className="hero-content">
              <div className="product-carousel-wrapper services-hero-wrapper">
                <div className="services-hero-text">
                  {activeService.carousel.map((slide, index) => (
                    <div key={index} className="service-quote-content">
                      <blockquote className="service-quote">
                        "{slide.quote}"
                      </blockquote>
                      <p className="service-quote-author">— {slide.author}</p>
                    </div>
                  ))}
                </div>
                <div className="product-launch-btn">
                  <a
                    href={activeService.id === "consulting" ? "/itservices" : "/staffing"}
                    className="launch-link"
                  >
                    Learn more about {activeService.title} →
                  </a>
                </div>
              </div>
            </div>
          </Col>

          {/* Right Side - Featured Services List */}
          <Col md={5} className="featured-products-col">
            <div className="featured-section">
              <h2 className="section-title">Featured Services</h2>
              <div className="products-list-zoho services-list-zoho">
                {featuredServices.map((service) => (
                  <div
                    key={service.id}
                    className={`product-item-zoho service-item-zoho ${
                      activeService.id === service.id ? "active" : ""
                    }`}
                    onMouseEnter={() => handleServiceHover(service)}
                    onClick={() => handleServiceHover(service)}
                  >
                    <div className="product-item-content">
                      <div className="product-text">
                        <h4 className={`product-name-zoho service-name-${service.id}`}>
                          <span className="product-name-main">{service.title}</span>
                        </h4>
                        <p className="product-description-zoho">{service.description}</p>
                      </div>
                      <span className="product-arrow">→</span>
                    </div>
                  </div>
                ))}
              </div>
              {/* Explore all services link removed - services split into separate pages */}
              {/* <a href="/services" className="explore-all-link">
                Explore all services →
              </a> */}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default NewLanding;

